import React, { useCallback, useEffect, useRef, useState } from 'react'

import { VideoSlider } from 'shared/components'

import classes from './ProductionDesktopV3.module.scss'
import { ProductionItemsDesktop } from './ProductionItems'
import classNames from 'classnames/bind'

import { SLIDER_ITEMS } from './SliderItem.const'

export const ProductionDesktopV3: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [containerClassName, setClassName] = useState(
    classNames(classes.wrapper__bg, classes['wrapper__bg--top'])
  )
  const [containerOverlayClassName, setOverlayClassName] = useState(
    classNames(classes['wrapper__bg--overlay--top'])
  )
  const items = ProductionItemsDesktop
  const element = containerRef.current

  const adjustBackgroundOnScroll = useCallback(() => {
    if (!element) {
      return
    }
    const viewPortHeight = window.innerHeight
    const elementScrolledFromTop =
      viewPortHeight + window.scrollY - element.offsetTop
    const elementHeight = element?.clientHeight || 0

    // 1) если доскролено до блока и проскроллено меньше одного вьюпорта, то фон наверху блока
    if (
      elementScrolledFromTop < viewPortHeight &&
      elementScrolledFromTop <= elementHeight
    ) {
      setClassName(classNames(classes['wrapper__bg--top']))
      setOverlayClassName(classNames(classes['wrapper__bg--overlay--top']))
    }

    // 2) если проскроллено больше высоты одного вьюпорта и не весь блок, то фиксируем фон
    if (elementScrolledFromTop > viewPortHeight) {
      setClassName(classNames(classes['wrapper__bg--fixed']))
      setOverlayClassName(classNames(classes['wrapper__bg--overlay--fixed']))
    }

    /* 3) если проскроллено больше одного вьюпорта и больше высоты блока (другими словами, 
     видим белое пространство после блока) */
    if (
      elementScrolledFromTop > viewPortHeight &&
      elementScrolledFromTop >= elementHeight
    ) {
      setClassName(classNames(classes['wrapper__bg--bottom']))
      setOverlayClassName(
        classNames(
          classes['wrapper__bg--overlay'],
          classes['wrapper__bg--overlay--bottom']
        )
      )
    }
  }, [element])

  useEffect(() => {
    window.addEventListener('scroll', adjustBackgroundOnScroll)
    return () => {
      window.removeEventListener('scroll', adjustBackgroundOnScroll)
    }
  }, [adjustBackgroundOnScroll])

  return (
    <div className={classes.wrapper} ref={containerRef}>
      <div className={`${containerClassName} ${classes.wrapper__bg}`}>
        <VideoSlider onlyVideo={true} slides={SLIDER_ITEMS} loop={true} />
      </div>
      <div
        className={`${containerOverlayClassName} ${classes['wrapper__bg--overlay']}`}
      />
      <div className={`${classes.container}`}>
        {items.map((item, itemIndex) => (
          <RenderItem key={itemIndex} {...item} itemIndex={itemIndex} />
        ))}
      </div>
    </div>
  )
}

type RenderItemProps = {
  itemIndex: number
  title: string
  descr?: string
}
const RenderItem: React.FC<RenderItemProps> = ({ title, descr }) => {
  return (
    <div
      className={`container ${classes.item} reveal-from-bottom-large`}
      data-reveal-delay={30}
    >
      <h2 className={classes.title}>{title}</h2>
      {descr && <div className={classes.descr}>{descr}</div>}
    </div>
  )
}
